// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Add, Edit, Update, Approve, Delete
// MODIFIED DATE : 20-08-2025

/* eslint-disable import/no-anonymous-default-export */
import BusinessLoanProposalActionTypes from './business-loan-proposal.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// ADD BUSINESS LOAN PROPOSAL
	addBusinessPropsalResponse: null,
	// UPDATE BUSINESS LOAN PROPOSAL
	updateBusinessProposalResponse: null,
	// GET BUSINESS LOAN PROPOSAL LIST
	getBusinessProposalResponse: null,
	getBusinessProposalListArr: [],
	// APPROVE BUSINESS PROPOSAL
	approveBusinessPropsalResponse: null,
	// FETCH BUSINESS LOAN PROPOSAL
	fetchBusinessPropsalResponse: null,
	fetchBusinessProposalArr: [],
	// DELETE BUSINESS LOAN PROPOSAL
	deleteBusinessPropsalResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*************** ADD BUSINESS LOAN PROPOSAL START ***************/
		case BusinessLoanProposalActionTypes.ADD_BUSINESS_LOAN_PROPOSAL_SUCCESS:
			return { ...state, addBusinessPropsalResponse: action.payload };

		case BusinessLoanProposalActionTypes.ADD_BUSINESS_LOAN_PROPOSAL_FAILURE:
			return { ...state, addBusinessPropsalResponse: action.payload };

		case BusinessLoanProposalActionTypes.ADD_BUSINESS_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, addBusinessPropsalResponse: null };

		/*************** ADD BUSINESS LOAN PROPOSAL END ***************/

		/*************** UPDATE BUSINESS LOAN PROPOSAL START ***************/
		case BusinessLoanProposalActionTypes.UPDATE_BUSINESS_LOAN_PROPOSAL_SUCCESS:
			return { ...state, updateBusinessProposalResponse: action.payload };

		case BusinessLoanProposalActionTypes.UPDATE_BUSINESS_LOAN_PROPOSAL_FAILURE:
			return { ...state, updateBusinessProposalResponse: action.payload };

		case BusinessLoanProposalActionTypes.UPDATE_BUSINESS_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, updateBusinessProposalResponse: null };

		/*************** UPDATE BUSINESS LOAN PROPOSAL END ***************/

		/*************** GET BUSINESS LOAN PROPOSAL LIST START ***************/
		case BusinessLoanProposalActionTypes.GET_BUSINESS_LOAN_PROPOSAL_LIST_SUCCESS:
			return {
				...state,
				getBusinessProposalResponse: action.payload,
				getBusinessProposalListArr: docodeHexResponse(
					action.payload,
					'GetBusinessLoanProposalListKey',
				),
			};

		case BusinessLoanProposalActionTypes.GET_BUSINESS_LOAN_PROPOSAL_LIST_FAILURE:
			return { ...state, getBusinessProposalResponse: action.payload };

		case BusinessLoanProposalActionTypes.GET_BUSINESS_LOAN_PROPOSAL_LIST_RESPONSE_CHANGED:
			return { ...state, getBusinessProposalResponse: null };

		/*************** GET BUSINESS LOAN PROPOSAL LIST END ***************/

		/*************** APPROVE BUSINESS PROPOSAL START ***************/
		case BusinessLoanProposalActionTypes.APPROVE_BUSINESS_PROPOSAL_SUCCESS:
			return {
				...state,
				approveBusinessPropsalResponse: action.payload,
			};

		case BusinessLoanProposalActionTypes.APPROVE_BUSINESS_PROPOSAL_FAILURE:
			return { ...state, approveBusinessPropsalResponse: action.payload };

		case BusinessLoanProposalActionTypes.APPROVE_BUSINESS_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, approveBusinessPropsalResponse: null };

		/*************** APPROVE BUSINESS PROPOSAL END ***************/

		/*************** FETCH BUSINESS LOAN PROPOSAL START ***************/
		case BusinessLoanProposalActionTypes.FETCH_BUSINESS_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				fetchBusinessPropsalResponse: action.payload,
				fetchBusinessProposalArr: docodeHexResponse(
					action.payload,
					'FetchBusinessLoanProposalKey',
				),
			};

		case BusinessLoanProposalActionTypes.FETCH_BUSINESS_LOAN_PROPOSAL_FAILURE:
			return { ...state, fetchBusinessPropsalResponse: action.payload };

		case BusinessLoanProposalActionTypes.FETCH_BUSINESS_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, fetchBusinessPropsalResponse: null, fetchBusinessProposalArr: [] };

		/*************** FETCH BUSINESS LOAN PROPOSAL END ***************/

		/*************** DELETE BUSINESS LOAN PROPOSAL START ***************/
		case BusinessLoanProposalActionTypes.DELETE_BUSINESS_LOAN_PROPOSAL_SUCCESS:
			return { ...state, deleteBusinessPropsalResponse: action.payload };

		case BusinessLoanProposalActionTypes.DELETE_BUSINESS_LOAN_PROPOSAL_FAILURE:
			return { ...state, deleteBusinessPropsalResponse: action.payload };

		case BusinessLoanProposalActionTypes.DELETE_BUSINESS_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, deleteBusinessPropsalResponse: null };

		/*************** DELETE BUSINESS LOAN PROPOSAL END ***************/

		default:
			return state;
	}
};
